export const ZIP_CODE_REGEXP = '^\\d{4}$';
export const TAX_NUMBER_REGEXP = '^\\d{8}-\\d{1}-\\d{2}$';
export const MOBILE_PHONE_REGEXP = '^(70|20|30|31|50)\\s\\d{3}\\s\\d{4}$';
export const PHONE_REGEXP = '^\\+?[\\d \\-\\(\\)]{5,20}$';
export const FULLNAME_REGEXP = "^[\\p{L}\\.\\-\\']+\\s[\\p{L}\\s\\.\\-\\']+$";
